// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"472":"settings","534":"deposits","668":"withdraws","685":"app-shell","809":"users","933":"auth","967":"wallets"}[chunkId] + "." + {"472":"40419d43","534":"e66820ee","668":"fa370316","685":"5c6923d4","809":"0b2ca93a","933":"e5106e51","967":"c83b39cc"}[chunkId] + ".css";
};